module.exports = __webpack_public_path__ + "img/exit_0.c298b4d8.png";